module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acuerdo"
  }, [_c('main', [(_vm.showFluxer[0]) ? _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('md-card-media', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.showFluxer[0].photoURL,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('md-card-header-text', [_c('div', {
    staticClass: "md-title name"
  }, [_vm._v("\n                      " + _vm._s(_vm.showFluxer[0].displayName) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('div', [(_vm.acuerdo.finalizado) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.acuerdo.sent && !_vm.acuerdo.finalizado) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("En Proceso")]) : _vm._e(), _vm._v(" "), (!_vm.acuerdo.sent) ? _c('p', {
    staticStyle: {
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("En Edicion")]) : _vm._e()])])])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465973ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acuerdo.vue
// module id = 376
// module chunks = 1